import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Button, Dropdown, Input, Icon } from 'semantic-ui-react';
import i18next from 'i18next';
import { saveCompany, editEntityField, uploadImage, fetchCompanyDataFromGoogle } from '../../../actions';
import currencyOptions from '../../../consts/CommonCurrency.json';
import timezones from '../../../consts/Timezones.json';

class CompanyEditor extends Component {
    handleSubmit = (event) => {
        this.props.saveCompany(this.props.entity);
        event.preventDefault();
    }

    handleFileUpload = ({ target }) => {
        const file = target.files[0];
        this.props.uploadImage(file, 'logo');
    }

    render() {
        const company = this.props.entity || {};

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <label>{i18next.t('name')}</label>
                    <input
                        placeholder={i18next.t('name')}
                        value={company.name || ''}
                        onChange={({ target }) => this.props.editEntityField('name', target.value)}
                        required
                    />
                </Form.Field>

                <Form.Field>
                    <label>{i18next.t('companyAddress')}</label>
                    <Input
                        fluid
                        placeholder={i18next.t('companyAddress')}
                        value={company.address || ''}
                        onChange={({ target }) => this.props.editEntityField('address', target.value)}
                        required
                        icon={
                            <Icon
                                name='search'
                                inverted
                                circular
                                link
                                onClick={() => this.props.fetchCompanyDataFromGoogle(company.address)}
                            />
                        }
                    />
                </Form.Field>

                <Form.Group widths='equal'>
                    <Form.Field>
                        <Input
                            fluid
                            placeholder={'lat'}
                            required
                            value={company.lat || ''}
                            onChange={({ target }) => this.props.editEntityField('lat', target.value)}
                            onBlur={() => this.props.editEntityField('lat', parseFloat(company.lat))}
                        />
                    </Form.Field>
                    <Form.Field>
                        <Input
                            fluid
                            placeholder={'lng'}
                            required
                            value={company.lng || ''}
                            onChange={({ target }) => this.props.editEntityField('lng', target.value)}
                            onBlur={() => this.props.editEntityField('lng', parseFloat(company.lng))}
                        />
                    </Form.Field>
                </Form.Group>

                <Form.Field>
                    <label>{i18next.t('timezone')}</label>
                    <Dropdown
                        required
                        fluid
                        search
                        selection
                        options={timezones.reduce((final, tz) => final.concat(tz.timezones.map((value, index) => ({ key: tz.name + value + index, value, text: `${tz.name} - ${value}` }))), [])}
                        value={company.timezone || ''}
                        onChange={(e, { value }) => this.props.editEntityField('timezone', value)}
                    />
                </Form.Field>

                <Form.Field>
                    <label>{i18next.t('currency')}</label>
                    <Dropdown
                        required
                        fluid
                        search
                        selection
                        options={Object.values(currencyOptions).map((currency) => ({ value: currency.code, text: currency.name + ' - ' + currency.code }))}
                        value={company.currencyCode || ''}
                        onChange={(e, { value }) => this.props.editEntityField('currencyCode', value)}
                    />
                </Form.Field>

                <Form.Field>
                    <label>{i18next.t('delivery')}</label>
                    <Form.Group inline>
                        <Form.Checkbox
                            label={i18next.t('delivery')}
                            checked={Boolean(company.supportCorporateDelivery)}
                            onChange={(e, { checked }) => this.props.editEntityField('supportCorporateDelivery', checked)}
                        />
                    </Form.Group>
                </Form.Field>

                <Form.Field>
                    <label>{i18next.t('image')}</label>
                    <Input
                        fluid
                        label={{ basic: true, image: company.imageUrl }}
                        labelPosition='right'
                        type="file"
                        onChange={this.handleFileUpload}
                    />
                </Form.Field>

                <Button primary type='submit' floated="right">
                    {i18next.t('save')}
                </Button>
            </Form>
        );
    }
}

CompanyEditor.propTypes = {
    saveCompany: PropTypes.func,
    editEntityField: PropTypes.func,
    uploadImage: PropTypes.func,
    fetchCompanyDataFromGoogle: PropTypes.func,
    entity: PropTypes.object,
    
};

const mapStateToProps = (state) => {
    const { entity } = state.editor;

    return { entity };
};

export default connect(mapStateToProps, { saveCompany, fetchCompanyDataFromGoogle, editEntityField, uploadImage })(CompanyEditor);
